import React from "react";
import './footer.css';
import { FaBriefcase, FaEnvelope, FaUser } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";



const FooterComponent = () => {

    return (
        <>
        <div className="navFooter">
          <button
            className="navFooterBackToTop"
            onClick={() => {
              if (window.scrollY !== 0) {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              } 
            }}
            aria-label="Back to top"
            style={{ all: 'unset', cursor: 'pointer', display: 'block', width: '100%' }}
          >
            <span className="navFooterBackToTopText">Back to top&nbsp;</span>
          </button>


        <div className="navFooterVerticalColumn col-md-12" data-wow-delay="0.1s">
          <div className="navFooterVerticalRow">
            <div className="navFooterLinkCol col-12 col-md-3">
              <div className="navFooterColHead" role="heading" aria-level="6">
                About SMART
              </div>
              <p>
                SMART is a platform committed to excellence in innovation, collaboration,
                and delivering modern solutions for everyday needs. Join us to explore more.
              </p>
              {/* <p>
                Our mission is to empower individuals and organizations through intelligent solutions,
                ensuring a smarter and more connected future.
              </p> */}
            </div>
            <div className="navFooterLinkCol col-12 col-md-3">
              <div className="navFooterColHead" role="heading" aria-level="6">
                Contact Us
              </div>
              <ul>
                <li className="nav_first">
                  <a className="nav_a"><FaUser className="me-2"/>Dr. Somsing Rathod</a>
                </li>
                <li>
                  <a className="nav_a"><FaBriefcase className="me-2"/>General Secretary, SMART</a>
                </li>
                <li>
                  <a className="nav_a"><FaPhone className="me-2"/>9880107412</a>
                </li>
                <li className="nav_last">
                  <a className="nav_a"><FaEnvelope className="me-2"/>smartforum2025@gmail.com</a>
                </li>
              </ul>
            </div>

            <div className="navFooterLinkCol col-12 col-md-3">
              <div className="navFooterColHead" role="heading" aria-level="6">
                Quick Links
              </div>
              <ul>
                <li className="nav_first">
                  <a className="nav_a" href="/aboutus">About Us</a>
                </li>
                <li>
                  <a className="nav_a" href="/register">Join SMART</a>
                </li>
                <li className="nav_last">
                  <a className="nav_a" href="/login">Log In</a>
                </li>
              </ul>
            </div>
            <div className="navFooterLinkCol col-12 col-md-3 justify-end">
              <div className="navFooterColHead" role="heading" aria-level="6">
                  Our Location
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31102.889869329203!2d77.63764301110143!3d12.980726037937773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1152121919ff%3A0x517c7feb6844e3a4!2sElectronics%20and%20Radar%20Development%20Establishment!5e0!3m2!1sen!2sin!4v1745996748048!5m2!1sen!2sin" 
                width="500" 
                height="220" 
                style={{border:'0'}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
        </div>

        <div className="navFooterCopyright">
          <ul>
            <li className="nav_first">
              <a id="" className="nav_a">Copyright © SMART  {new Date().getFullYear()} – All Rights Reserved.</a>
              <br />
            </li>
          </ul>
        </div>
      </div>
</>
  )
}
export default FooterComponent;